// main.jsx
// Primero: en la demo, localStorage pasa a ser sessionStorage (ver el módulo).
import './lib/demo/sessionOnly.js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { initTheme } from './lib/theme.js'
import { registerServiceWorker } from './lib/pwa.js'
import './index.css'

// Tras un deploy, una pestaña abierta con el bundle anterior pide chunks que ya no existen
// (cambió su hash) y el import dinámico falla ("Importing a module script failed", p. ej. al
// cargar Firebase para entrar). Vite avisa con `vite:preloadError`: se recarga UNA vez para
// tomar el index.html nuevo. La marca en sessionStorage evita un bucle si el fallo es otro.
window.addEventListener('vite:preloadError', (event) => {
  try {
    if (sessionStorage.getItem('soedia:chunk-reload')) return;
    sessionStorage.setItem('soedia:chunk-reload', '1');
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => {
  setTimeout(() => {
    try {
      sessionStorage.removeItem('soedia:chunk-reload');
    } catch {}
  }, 10000);
});

// Antes del primer render: aplica .dark al <html> según lo guardado o el sistema.
initTheme()

// App instalable: service worker (abre sin red y más rápido desde la pantalla de inicio).
registerServiceWorker()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)